// extracted by mini-css-extract-plugin
export var cardIcon = "_a6-4";
export var checkboxCard = "_a6-0";
export var checkboxCardSelected = "_a6-1";
export var disabled = "_a6-2";
export var outerBorder = "_a6-3";
export var spacerMedium = "_a6-7";
export var spacerSmall = "_a6-6";
export var spacerXsmall = "_a6-5";